import { z } from 'zod'
import ApiService from '../api.service'

import { zod } from '@acme/core'
import { EspelhoPonto } from './espelho'

export interface CreateCalculo {
    funcionarioIds?: number[]
    competencia: string
    empresaId: number
    justificativa?: string
}

type Query =
    | { competencia: string; empresaId: number }
    | { id: number }
    | { funcionarioId: number; competencia: string }

const historicoCalculoSchema = zod.HistoricoCalculoSchema.extend({
    logs: z.array(zod.HistoricoCalculoLogsSchema),
})

export type LogCalculos = z.infer<typeof zod.LogCalculosSchema>

export type FuncionarioComEspelhoAceito = {
    funcionarioId: number
    nome: string
    matricula: number
}

export type HistoricoCalculo = z.infer<typeof historicoCalculoSchema> & {
    /** Funcionários ignorados no cálculo por já terem aceitado o espelho */
    funcionariosComEspelhoAceito?: FuncionarioComEspelhoAceito[]
}

export type CalculoEmpresaInput = {
    empresaId: number | number[]
    competencia: string
    centroCustoId?: number
    baixarPdf?: boolean
    baixarZip?: boolean
    funcionarioIds?: number[]
}

const historico = new ApiService<CalculoEmpresaInput, HistoricoCalculo>(
    'calculo-ponto',
)

const service = new ApiService<CreateCalculo, EspelhoPonto, Query>('calculo')

export const calculo = Object.assign(service, {
    historico,
})
